import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from 'src/app/shared/services/common.service';
import { UserRoutingModule } from '../user-routing/user-routing.module';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { FormFieldsTrimer } from 'src/app/shared/Validations/FormFieldsTrimer';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { FitersserviceService } from '../filters/filterspopup/fitersservice.service';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { UntypedFormGroup, Validators, FormControl, UntypedFormBuilder, } from '@angular/forms';
import { constants } from 'src/app/shared/common/contants';
import { validationmethod } from 'src/app/shared/common/validationmethod';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { EditButton } from 'src/app/shared/common/Editbutton';
import { FunctionalMappingPopupComponent } from './functional-mapping-popup/functional-mapping-popup.component';

@Component({
    selector: 'app-functional-mapping',
    templateUrl: './functional-mapping.component.html',
    styleUrls: ['./functional-mapping.component.scss'],
    standalone: false
})
/**
   *@Author : Shyam
   * @Date :19-02-2025
   *@Note Functional Mapping component
   */
export class FunctionalMappingComponent implements OnInit {
  components: any
  gridApi;
  lastpage;
  currentpage;
  nextpage;
  nextpageplusone;
  totalpages;
  pagesize;
  paginationPageSize;
  rowClassRules;
  paginationNumberFormatter;
  columnDefs;
  defaultColDef;
  backgroundColorScreen;
  buttonColor;
  fieldId: any;
  getdata: null;
  uploadId:any;
  rowSelection:string ='single';
  single;
  updatedData = [];


   constructor(private userRoutingModule:UserRoutingModule,private msg: ErrorMessages,private snackbar: MatSnackBar, private dialog: MatDialog, private validation: validationmethod,private fb: UntypedFormBuilder,private formFieldsTrimer: FormFieldsTrimer,private localStorageSettings: LocalStorageSettingsService,private constants: constants,private service:FitersserviceService,private spinner: NgxUiLoaderService,private commonservice:CommonService) {
      
      this.components = {
        buttonRenderer: EditButton,
      }
     }


  ngOnInit(): void {

    this.columnDefs = [
      
     
      {
        headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
        pinned: 'left',
        lockPinned: true,
        cellRendererParams: {
          
          edit: this.editIcon.bind(this),
         
          
        }, width: 150

      },
      { headerName: 'Object Field ID', headerTooltip: 'Object Field ID', tooltipValueGetter: (params) => 'Object Field ID : ' + params.value, field: 'objectfieldid', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Object Name', headerTooltip: 'Object Name', tooltipValueGetter: (params) => 'Object Name : ' + params.value, field: 'objectname', filter: 'agTextColumnFilter', width: 250 },
     
      { headerName: 'Vault Field Presence', headerTooltip: 'Vault Field Presence', tooltipValueGetter: (params) => 'Vault Field Presence : ' + params.value, field: 'vaultfieldpresence', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Veeva UI section', headerTooltip: 'Veeva UI section', tooltipValueGetter: (params) => 'Veeva UI section : ' + params.value, field: 'veevauisection', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Vault UI Sub Section', headerTooltip: 'Vault UI Sub Section', tooltipValueGetter: (params) => 'Vault UI Sub Section : ' + params.value, field: 'vaultuisubsection', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Veeva UI field', headerTooltip: 'Veeva UI field', tooltipValueGetter: (params) => 'Veeva UI field : ' + params.value, field: 'veevauifield', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Mapping Type', headerTooltip: 'Mapping Type', tooltipValueGetter: (params) => 'Mapping Type : ' + params.value, field: 'mappingtype', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Logic', headerTooltip: 'Logic', tooltipValueGetter: (params) => 'Logic : ' + params.value, field: 'logic', filter: 'agTextColumnFilter', editable: true,  width: 250 },
      { headerName: 'SQL', headerTooltip: 'SQL', tooltipValueGetter: (params) => 'SQL : ' + params.value, field: 'sql', filter: 'agTextColumnFilter', width: 250 },
    ]

    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
  }

  onBtExport() {
    this.gridApi.api.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi.api) {
      this.lastpage = this.gridApi.api.paginationIsLastPageFound();
      this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1
      this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.gridApi.api.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {

    this.gridApi.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pagesize
    this.gridApi.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridApi.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridApi.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.gridApi.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.gridApi.api.paginationGoToLastPage();
  }

  onGridReady(params){
    this.gridApi = params;
    //this.gridColumnApi = params.columnApi;
    //this.gridApi.sizeColumnsToFit();
    // params.api.addEventListener('cellValueChanged', this.onCellValueChanged.bind(this));
    params.api.sizeColumnsToFit();
    params.api.setGridOption('rowData', [])
   

  }
  openSaveForm(buttonName){

  }

  mappingFile(event: any, filecheck: any) {
    // debugger
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file: File = input.files[0];
      const extension = file.name.split('.').pop().toLowerCase();

      // Basic CSV file validation
      if (extension === 'xls' || extension === 'xlsx') {
        console.log('CSV file selected:', file);
  
        // Create FormData and append the file
        const formData = new FormData();
        formData.append('file', file, file.name);
        console.log(formData)
        console.log('Selected file:', file);
        console.log('File size:', file.size);

        formData.forEach((value, key) => {
          console.log(key, value);
        });
  
        // Call the service method and subscribe to the response
        this.commonservice.uploadingMappingFile(formData).subscribe({
          next: (response) => {
            console.log('File upload successful', response);
            console.log(response.message)
            this.uploadId = response.upload_id
            console.log(this.uploadId);
            this.snackbar.open(response.message, "OK",{duration:5000});
          },
          error: (error: any) => {
            console.error('File upload failed', error);
            this.snackbar.open(error.message, "OK",{duration:5000});
          },
          complete: () => {
            console.log('File upload completed');
            input.value = "";
          }
        });
        
      } else {
        console.error('Only CSV files are allowed.');
        // Optionally, show an error message to the user
      }
    }
  }
  

  onRefresh(){
    // debugger
    console.log("Inside refresh.....")
    //  this.uploadId = 1035;
    console.log(this.uploadId)
   
    const formDataforretrieve = new FormData();  
    formDataforretrieve.append('upload_id', this.uploadId);
    formDataforretrieve.forEach((value, key) => {
      console.log(key, value);
    });
    this.commonservice.retrieveFunctionalMapping(formDataforretrieve).subscribe({
      next: (response) => {
        if(response.message){
          this.snackbar.open(response.message, "OK", { duration: 5000 });
          return
        }else{
        console.log('retrieve successful', response);
        console.log(response.data)
        const transformedData = this.transformResponseData(response.data);
        console.log('Transformed data:', transformedData);
        this.gridApi.api.setGridOption('rowData', transformedData);
        }
      },
      error: (error: any) => {
        console.error('retrieve failed', error);
        this.snackbar.open("Failed to retrieve data", "OK", { duration: 5000 });
      },
      complete: () => {
        console.log('retrieve  completed');
      }
    });
    
   

  }

  transformResponseData(data: any[]): any[] {
    return data.map(item => ({
      objectfieldid: item["Object Field ID"],
      objectname: item["Object Name"],
      vaultfieldpresence: item["Vault Field Presence"],
      veevauisection: item["Veeva UI section"],
      vaultuisubsection: item["Vault UI Sub Section"],
      veevauifield: item["Veeva UI field"],
      mappingtype: item["Mapping Type"],
      logic: item["Logic"],
      sql: item["sql"]
    }));
  }
  

  
  editIcon(event){
    console.log(event)
    let rowData = event.rowData
    console.log(rowData);
    var obj = {

      "logic":event.rowData.logic
    }
    console.log(obj)
    let dialogRef = this.dialog.open(FunctionalMappingPopupComponent,{
      panelClass: 'custom-dialog-container-materialFulfilment',
     
      width: "70%",
      autoFocus: false,
      // maxWidth: '100vw',
      height: "85%",
        data: { editData: event.rowData , uploadId: this.uploadId},
        disableClose: true,
    } );

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Dialog closed with data:', result);
        const transformedData = this.transformResponseData(result);
        console.log('Transformed data:', transformedData);
        this.gridApi.api.setGridOption('rowData', transformedData);
        this.updatedData = null;
      }
    });
  }

   
  

  
  
  
}
